import { TagDataCreate, TagsSuccessResponse, TagSuccessResponse } from "../types/api/tag";
import { doDeleteRequest, doGetRequest, doPostRequest } from "./mainAPI";
import { TAG } from "../constants/mainAPI";
import { toFormData } from "../utils/toFormData";

export const getTags = (
    callback?: (resp: TagsSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
    searchParams?: Record<string, any>,
) => {
    return doGetRequest(TAG, true, searchParams, callback, errorCallback);
};

export const getTag = (
    tagId: number,
    callback?: (resp: TagSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
) => {
    return doGetRequest(`${TAG}/${tagId}`, true, {}, callback, errorCallback);
};

export const createNewTag = (
    data: TagDataCreate,
    callback?: (resp: TagSuccessResponse) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPostRequest(TAG, true, formData, {}, callback, errorCallback);
};

export const deleteTag = (tagId: number, callback?: (resp: any) => void, errorCallback?: (resp: any) => void) => {
    return doDeleteRequest(`${TAG}/${tagId}`, true, {}, callback, errorCallback);
};
